// Shikshan Nivesh brand mark
// Theme-aware via CSS variables (--sn-accent, --sn-fg).
import { CSSProperties } from "react";

interface LogoMarkProps {
  size?: number;
  className?: string;
}

export function LogoMark({ size = 32, className = "" }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      shapeRendering="crispEdges"
      className={className}
      role="img"
      aria-label="Shikshan Nivesh"
    >
      <path
        d="M 22 38 L 38 60 L 22 82"
        stroke="var(--sn-brand, var(--sn-accent))"
        strokeWidth="12"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
      />
      <rect x="48" y="34" width="34" height="12" fill="var(--sn-fg)" />
      <rect x="48" y="54" width="54" height="12" fill="var(--sn-fg)" />
      <rect x="48" y="74" width="44" height="12" fill="var(--sn-fg)" />
    </svg>
  );
}

interface WordmarkProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function Wordmark({ size = 18, className = "", style }: WordmarkProps) {
  return (
    <span
      className={className}
      style={{
        fontFamily: "var(--sn-font-ui)",
        fontSize: size,
        fontWeight: 600,
        letterSpacing: "-0.03em",
        textTransform: "lowercase",
        lineHeight: 1,
        color: "var(--sn-fg)",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      shikshan nivesh<span style={{ color: "var(--sn-brand, var(--sn-accent))" }}>/</span>
    </span>
  );
}

interface LogoLockupProps {
  markSize?: number;
  wordSize?: number;
  className?: string;
}

export function LogoLockup({
  markSize = 28,
  wordSize = 16,
  className = "",
}: LogoLockupProps) {
  return (
    <div
      className={className}
      style={{ display: "flex", alignItems: "center", gap: 12 }}
    >
      <LogoMark size={markSize} />
      <Wordmark size={wordSize} />
    </div>
  );
}
